/** Publieke site-URL en herbruikbare klantportaal-teksten (mail + website). */
export const SITE_URL = "https://taxiritje.nl";

export const CUSTOMER_PORTAL_PATH = "/klant/login";
export const CUSTOMER_PORTAL_URL = `${SITE_URL}${CUSTOMER_PORTAL_PATH}`;

/** Uitleg die klanten zowel in de bevestigingsmail als op de site zien. */
export const CUSTOMER_PORTAL_TITLE = "Uw rit online beheren";
export const CUSTOMER_PORTAL_INTRO =
  "Wij hebben automatisch een account voor u aangemaakt. Uw wachtwoord ontvangt u in een aparte e-mail; na inloggen kunt u dit direct wijzigen.";
export const CUSTOMER_PORTAL_POINTS = [
  "Bekijk al uw ritten en de status ervan",
  "Wijzig datum, tijd, vluchtnummer of bagage tot 24 uur voor het ophalen",
  "Binnen 24 uur voor het ophalen? Bel ons dan even, dan regelen wij het",
];

export const FAQ_URL = `${SITE_URL}/faq`;

export function customerPortalEmailText(locale: "nl" | "en" = "nl") {
  if (locale === "en") return ["Manage your ride online", "We have created an account for you. Your password arrives in a separate email; you can change it after signing in.", "- View all your rides and their status\n- Change your date, time, flight number or luggage up to 24 hours before pick-up\n- Within 24 hours of pick-up? Call us and we will help you", `Sign in: ${SITE_URL}/en/customer/login`].join("\n\n");
  return [
    CUSTOMER_PORTAL_TITLE,
    "",
    CUSTOMER_PORTAL_INTRO,
    "",
    CUSTOMER_PORTAL_POINTS.map((p) => `- ${p}`).join("\n"),
    "",
    `Inloggen: ${CUSTOMER_PORTAL_URL}`,
  ].join("\n");
}

/**
 * Ophaalinstructies voor ritten vanaf een luchthaven. Schiphol heeft een vaste
 * ophaalplek; op andere luchthavens neemt de chauffeur zelf contact op.
 */
export function airportPickupEmailText(fromLabel?: string | null, locale: "nl" | "en" = "nl") {
  if (locale === "en") return [
    (fromLabel ?? "").toLowerCase().includes("schiphol") ? "Pick-up at Schiphol\n\nPlease meet your driver at Departures (upstairs), location 3C." : "Airport pick-up\n\nYour driver will call you after landing to agree on the exact meeting point. Please keep your phone switched on after landing.",
    "The time you entered is your landing time, not your pick-up time. We pick you up 45–60 minutes after landing.",
    "Your driver waits free of charge until 80 minutes after landing.",
    `Need longer? Arrange this directly with your driver; see the waiting-time terms: ${SITE_URL}/en/faq`,
  ].join("\n\n");
  const label = (fromLabel ?? "").toLowerCase();
  const waiting = [
    "De tijd die u opgaf is uw landingstijd, geen ophaaltijd. Wij halen u 45-60 minuten na de landing op.",
    "De chauffeur wacht tot 80 minuten na de landing gratis op u.",
    `Duurt het langer? Dan regelt u dat rechtstreeks met de chauffeur; de voorwaarden staan in de veelgestelde vragen: ${FAQ_URL}`,
  ];
  if (label.includes("schiphol")) {
    return [
      "Ophalen op Schiphol",
      "",
      "U wordt verwacht bij de vertrekhal (boven), locatie 3C.",
      ...waiting,
    ].join("\n");
  }
  return [
    "Ophalen op de luchthaven",
    "",
    "Na de landing neemt uw chauffeur telefonisch contact met u op en spreekt hij de exacte ophaalplek met u af. Houd uw telefoon daarom aan zodra u geland bent.",
    ...waiting,
  ].join("\n");
}

/** Praktische informatie die in elke ritbevestiging thuishoort. */
export function practicalInfoEmailText(locale: "nl" | "en" = "nl") {
  if (locale === "en") return ["Practical information", `- Download your VAT invoice from your account: ${SITE_URL}/en/customer/login\n- Add your billing or company details in your account\n- Change or cancel up to 24 hours before pick-up\n- Keep your phone reachable around pick-up time; your driver calls if delayed\n- Find answers to common questions: ${SITE_URL}/en/faq`].join("\n\n");
  return [
    "Praktische informatie",
    "",
    `- Uw factuur met btw vindt u na inloggen in uw account onder Facturen: ${CUSTOMER_PORTAL_URL}`,
    "- Factuur- of bedrijfsgegevens vult u daar zelf aan, dan staan die meteen goed op de factuur",
    "- Wijzigen of annuleren kan tot 24 uur voor het ophalen in uw account",
    "- Houd uw telefoon bereikbaar rond de ophaaltijd; de chauffeur belt u bij vertraging",
    `- Antwoord op de meeste vragen vindt u in de veelgestelde vragen: ${FAQ_URL}`,
  ].join("\n");
}
